import { connect } from "vuex-connect";
import { MyContentsDelete } from "../../../components";

export default connect({
  actionsToProps: {
    deleteContents: (dispatch, value) => {
      return dispatch("myContents/deleteContents", value);
    }
  }
})(MyContentsDelete.name, MyContentsDelete);
